<template>
  <div class="banner">
    <div class="content" ref="content">
      <img class="content-bg" src="../assets/model-banner.png"/>
      <div class="logo-left" :class="{'logo-left-international': value === '2'}" @click="redirectToHome"></div>
      <div class="switch-lang">
        <el-select v-model="value" placeholder="" @change="changeLang">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <template v-if="iscn">
        <div class="text model-banner-text" ref="text">
          成为循环可持续企业榜样
        </div>
        <div class="text-desc model-banner-text-desc">
          我们将以身作则，将循环与可持续融入到业务方方面面。<br/>
          同时赋能行业生态，引领上下游伙伴，共同促进循环经济发展。
        </div>
      </template>
      <template v-if="!iscn">
        <div class="text text-en model-banner-text" ref="text">
          Becoming a role model for<br/>
          circular and sustainable business practices
        </div>
        <div class="text-desc model-banner-text-desc">
          We will lead by example, integrating circularity and sustainability into every aspect of our business. At the same time,<br/>
          we will empower the industry ecosystem, guiding upstream and downstream partners to jointly promote the development of the circular economy.
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Rellax from 'rellax'
import { url } from '@zz-common/zz-utils'

export default Vue.extend({
  name: 'banner-area',
  data() {
    return {
      options: [
        {
          value: '1',
          label: '中文(简体)'
        },
        {
          value: '2',
          label: 'English'
        }
      ],
      value: '1'
    }
  },
  computed: {
    iscn: function() {
      return this.$store.state.lang === 'zh-cn'
    }
  },
  beforeMount() {},
  mounted() {
    const windowHeight = window.innerHeight
    const windowWidth = window.innerWidth

    this.$refs.content.style.height = windowHeight + 'px'
    let addition = 0
    if (windowHeight / windowWidth < 0.5) {
      try {
        addition = windowHeight * 0.1
        // magic number，反正就是算个比例
        this.$refs.bannerLogo.style.top = (244 * windowHeight) / 761 - addition + 'px'
        this.iscn && (this.$refs.text.style.top = (550 * windowHeight) / 761 - addition + 'px')
        this.$refs.mouse.style.top = 'initial'
        this.$refs.mouse.style.bottom = '20px'
      } catch (error) {}
    }

    if (windowHeight / windowWidth > 0.6) {
      try {
        addition = windowHeight * 0.1
        // magic number，反正就是算个比例
        this.$refs.bannerLogo.style.top = (300 * windowHeight) / 761 - addition + 'px'
        this.iscn && (this.$refs.text.style.top = (550 * windowHeight) / 761 - addition + 'px')
        this.$refs.mouse.style.top = 'initial'
        this.$refs.mouse.style.bottom = '20px'
      } catch (error) {}
    }

    // iscn那么value就为1，否则就为2
    this.value = this.iscn ? '1' : '2'
    if (this.value === '1') {
      this.options = [
        {
          value: '2',
          label: 'English'
        }
      ]
    } else {
      this.options = [
        {
          value: '1',
          label: '中文(简体)'
        }
      ]
    }

    // const min = this.iscn ? 0 : 1000

    // 添加 text-animate 类名
    // this.iscn && this.$refs.text.classList.add('text-animate')
    // setTimeout(() => {
    //   this.$refs.text.classList.add('text-animate')
    //   this.$refs.mouse.classList.add('mouse-animate')
    // }, 1500 - min)
    // setTimeout(() => {
    //   this.$refs.mouse.classList.add('mouse-animate-flash')
    // }, 2500 - min)
    this.initAnimation()
    setTimeout(() => {
      new Rellax('.model-banner-text', {
        speed: 2,
        center: false,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false
      })
      new Rellax('.model-banner-text-desc', {
        speed: 2,
        center: false,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false
      })
    }, 1000)

    // new Rellax('.text-quick', {
    //   speed: -10,
    //   center: false,
    //   wrapper: null,
    //   round: true,
    //   vertical: true,
    //   horizontal: false
    // })
  },
  methods: {
    initAnimation () {
      // 监听滚动事件，当元素earthPic进入视口时，给元素增加动画类
      // setTimeout(() => {
      //   if (!this.$refs.text.classList.contains('zoom-in')) {
      //     console.log('那应该增加了呀')
      //     this.$refs.text.classList.add('zoom-in')
      //   }
      // }, 1000)
      // 监听滚动事件，当元素earthPic进入视口时，给元素增加动画类
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // 冰川图部分
            if (entry.target.classList.contains('text') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelector('.text')?.classList?.add('zoom-in')
                document.querySelector('.text-desc')?.classList?.add('zoom-in')
              }, 70)
            }
          })
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.2
        }
      )
      observer.observe(document.querySelector('.text') as Element)
      observer.observe(document.querySelector('.text-desc') as Element)
    },
    changeLang(val) {
      // 如果val为1，那么URL为当前页面去除lang参数的URL，否则为当前页面加上lang=en的URL，考虑hash路由情况
      // 去掉ULR的hash参数
      let u = location.href
      if (val === '1') {
        u = this.removeUrlParam(u, 'lang')
      } else {
        u = url.setParams(
          {
            lang: 'en'
          },
          u
        )
      }
      location.href = u
    },
    removeUrlParam(url, name) {
      const baseUrl = url.split('?')[0] + '?'
      const query = url.split('?')[1]
      if (query.indexOf(name) > -1) {
        const obj = {}
        const arr = query.split('&')
        for (let i = 0; i < arr.length; i++) {
          arr[i] = arr[i].split('=')
          obj[arr[i][0]] = arr[i][1]
        }
        delete obj[name]
        const url =
          baseUrl +
          JSON.stringify(obj)
            .replace(/["{}]/g, '')
            .replace(/:/g, '=')
            .replace(/,/g, '&') +
            '#/intro-model'
        return url
      } else {
        return url
      }
    },
    redirectToHome() {
      location.href = 'https://www.zhuanzhuan.com'
    }
  }
})
</script>

<style lang="scss">
.el-select {
  width: 130px;
  height: 36px;
  border-radius: 20px;
}

.el-input__inner {
  padding: 7px 45px 7px 20px;
  color: #000;
  font-size: 14px;
  line-height: 16px;
  // background-color: #000;
  background-color: #fff;
  border: 0;
  border-radius: 20px;
}

.el-select .el-input .el-select__caret {
  color: #000;
}

.el-popper[x-placement^='bottom'] {
  margin-top: 0;
}

.el-input.is-focus .el-input__inner {
  color: #000;
  // color: #fff;
  border-radius: 20px 20px 0 0;
}
.el-select-dropdown {
  margin: 0;
  padding: 0;
  background-color: #000;
  border: 0;
  border-radius: 0 0 20px 20px;
  transition: none;
}
.popper__arrow {
  display: none !important;
}
.el-select-dropdown__item {
  position: relative;
  // color: #fff !important;
  color: #000 !important;
  font-size: 14px !important;
  // background-color: #000 !important;
  background-color: #fff !important;
}
.el-select-dropdown__item:hover {
  // color: red !important;
  color: #A2C6DB !important;
}
.el-select-dropdown__item:hover::after {
  display: inline-block;
}
.el-select-dropdown__item::after {
  position: absolute;
  top: 10px;
  right: 10px;
  display: none;
  font-weight: 400;
  font-family: element-icons !important;
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-transform: none;
  vertical-align: baseline;
  content: '\e6da';
  -webkit-font-smoothing: antialiased;
}

.el-select-dropdown__list,
.el-select-dropdown__item {
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 0 0 20px 20px;
}
</style>

<style scoped lang="scss">
@keyframes zoomIn {
  from {
    transform: scale3d(0.7, 0.7, 0.7);
    opacity: 0;
  }

  50% {
    opacity: 0.3;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}
@keyframes flash {
  from,
  50%,
  to {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0.5;
  }
}
.zoom-in {
  animation: zoomIn 1s 0s forwards;
  animation-timing-function: linear;
}

.zoom-in-fast {
  animation: zoomIn 800ms 0s forwards;
  animation-timing-function: linear;
}
.banner {
  width: 100%;
  background: #399f67;
}
.content {
  position: relative;
  width: 1920px;
  min-width: 1280px;
  max-width: 1920px;
  height: 1080px;
  margin: 0 auto;
  // background: #399f67 url('https://pic6.zhuanstatic.com/zhuanzh/045c74e6-6cc8-4637-9af4-a2ddbe72e979.png')no-repeat center center;
  // background-size: auto 100%;
}
.content-bg {
  height: 100%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
}

.logo-right {
  position: absolute;
  top: 91px;
  right: 114px;
  width: 686px;
  height: 52px;
  background: url('../assets/banner-1.png') no-repeat 0 0/ 100% 100%;
}

.logo-left {
  position: absolute;
  top: 20px;
  left: 240px;
  width: 116px;
  height: 36px;
  background: url('../assets/logo-zz.png') no-repeat 0 0/ 100% 100%;
}
.logo-left-international {
  // width: 77px;
  // height: 46px;
  width: 116px;
  height: 36px;
  background: url('../assets/logo-zz.png') no-repeat 0 0/ 100% 100%;
}

.switch-lang {
  position: absolute;
  top: 20px;
  right: 200px;
}

.banner-logo {
  position: absolute;
  top: 303px;
  left: 50%;
  width: 1623px;
  height: 331px;
  margin-left: -812px;
  background: url(../assets/banner-2.png) no-repeat 0 0/ 100% 100%;
}

// .banner-logo {
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   width: 1623px;
//   height: 331px;
//   margin-left: -812px;
//   margin-top: -165px;
//   background: url(../assets/banner-2.png) no-repeat 0 0/ 100% 100%;
// }

.en-logo {
  position: absolute;
  top: 320px;
  width: 100%;
  color: #000;
  font-size: 172px;
  font-family: alibaba;
  line-height: 172px;
  text-align: center;
}

.text {
  position: absolute;
  // top: 679px;
  // top: 50%;
  // margin-top: -50px;
  width: 100%;
  bottom: 176px;
  // color: #000;
  // font-size: 22px;
  // line-height: 22px;
  text-align: center;
  opacity: 0;
  font-family: alibaba;
  font-weight: 1000;
  font-size: 100px;
  color: #FFFFFF;
  line-height: 100px;
  text-shadow: 0px 6px 80px rgba(0,22,59,0.8);
  &.text-en {
    font-size: 80px;
    line-height: 80px;
    margin-top: -80px;
  }
}
.text-desc {
  position: absolute;
  width: 100%;
  bottom: 84px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 24px;
  color: #FFFFFF;
  line-height: 36px;
  text-align: center;
  opacity: 0;
}

.text-animate {
  animation: fadeIn 1.5s 0s forwards;
}

.mouse-animate {
  animation: fadeIn 1s 0s forwards;
}

.mouse-animate-flash {
  animation: flash 2s 0s forwards;
}

.mouse {
  position: absolute;
  // bottom: 124px;
  bottom: 0;
  left: 50%;
  width: 506px;
  height: 248px;
  margin-left: -253px;
  background: url('../assets/slogan-zz.png') no-repeat 0 0/ 100% 100%;
  opacity: 0;
}
.mouse-en {
  position: absolute;
  bottom: 124px;
  left: 50%;
  color: #ffffff;
  // width: 60px;
  // height: 233px;
  font-size: 30px;
  margin-left: -140px;
  // background: url('../assets/banner-3.png') no-repeat 0 0/ 100% 100%;
  opacity: 0;
  // transform: translate(-50%, 0);
}

</style>
